import { render, staticRenderFns } from "./DataProcessingAgreement.vue?vue&type=template&id=2f5e894a&scoped=true"
import script from "./DataProcessingAgreement.vue?vue&type=script&lang=js"
export * from "./DataProcessingAgreement.vue?vue&type=script&lang=js"
import style0 from "./DataProcessingAgreement.vue?vue&type=style&index=0&id=2f5e894a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5e894a",
  null
  
)

export default component.exports